<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container" *ngIf="exportOfferAd">
      <div class="col-12">
        <p-breadcrumb class="max-w-full custom-breadcrumb" [model]="breadcrumbItems" *ngIf="lang == 'es'"></p-breadcrumb>
        <p-breadcrumb class="max-w-full custom-breadcrumb" [model]="breadcrumbItemsEN" *ngIf="lang == 'en'"></p-breadcrumb>
      </div>

      <div class="section-top">
        <div class="column-left-top">
          <app-export-offer-detail-carousel [offerAd]="exportOfferAd"></app-export-offer-detail-carousel>
        </div>

        <div class="column-right-top">
          <div class="header-card pd-top">
            <div class="section-titles">

              <h2 class="title-product">
                {{exportOfferAd.variety.species | speciesName | translate}} / {{exportOfferAd.variety.name}}
              </h2>
              <p class="title-price">{{ exportOfferAd.listPrice | currency: 'USD':'US$'}}
                {{getIncoterms(exportOfferAd.typeSale)}}
              </p>
            </div>
            <div class="only-desktop">
              <app-social-media-share [url]="urlRoute">
              </app-social-media-share>
            </div>
            <div class="only-mobile">
              <app-qr-image [imageQrData]="imageData" width="60px" height="60px"></app-qr-image>
            </div>
          </div>

          <div class="section-main-info">

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.CasePerPalletsText' | translate}}:</h5>
              <p class="data-main-info">
                {{exportOfferAd.caseQuantityPerPallet }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.SpeciesSizeText' | translate}}:</h5>
              <p class="data-main-info">
                <app-text-preview
                  [text]="exportOfferAd.speciesSize ? exportOfferAd.speciesSize : getNoAvailableLabel()"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.ShelfLife' | translate}}:</h5>
              <p class="data-main-info">
                {{ exportOfferAd.shelfLife ? exportOfferAd.shelfLife +  " " + translate.instant('MarketplacePage.WishList.ExportOfferModal.DayShelflifeText') : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.AvailablePalletsText' | translate}}:</h5>
              <p class="data-main-info">
                {{ exportOfferAd.availablePallets }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'MarketplacePage.WishList.ExportOfferModal.NetKilosText' | translate}}:</h5>
              <p class="data-main-info">
                {{ exportOfferAd.netKilos ? exportOfferAd.netKilos + ' Kg' : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-main-info">
              <h5 class="span-info">{{'ExportOffer.ExportOfferDetail.AvailableProductCertificates2' | translate}}:</h5>
              <section *ngIf="selectedProductCertificateTypes.length > 0">
                <ng-container *ngFor="let productCertificateType of selectedProductCertificateTypes">
                  <p class="data-main-info" *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</p>
                  <p class="data-main-info" *ngIf="productCertificateType.isOther">{{ exportOfferAd.otherCertificateType }}</p>
                </ng-container>
              </section>
              <span *ngIf="selectedProductCertificateTypes.length == 0" style="font-weight: bolder;">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
            </div>

          </div>

          <div class="container-bottom">
            <div>
              <!--
                <p-button label="{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.PurchaseNowButton' | translate}}" (onClick)="navigateToLogin()" [loading]="loading"></p-button>
              -->
              <button class="main-btn mg-bottom" (click)="navigateToLogin()">{{'MarketplacePage.WishList.ExportOfferModal.PurchaseForm.PurchaseButton' | translate}}</button>
            </div>
            <div class="only-desktop" style="padding-left:1em">
              <app-qr-image [imageQrData]="imageData" width="160px" height="160px"></app-qr-image>
            </div>
          </div>

        </div>
      </div>
      <!--
      <app-export-offer-detail-description [offer]="exportOfferAd"></app-export-offer-detail-description>
      -->

      <div class="section-description only-desktop">
        <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.SpecieDescription.Title' | translate}}</h2>
        <div class="section-description-info">
          <div class="rowInfo">
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.DescriptionText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.description ? speciesDescription.description : getAvailableLabel() }}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.TechnicalCharacteristicsText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.technicalCharacteristics ? speciesDescription.technicalCharacteristics : getAvailableLabel()}}</p>
            </div>

            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.ExportedVarietiesText' | translate}}:</span>
              <p class="text-info">{{exportOfferAd.variety.species.exportVarieties}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.QualityControlCriteriaText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.qualityControlCriteria ? speciesDescription.qualityControlCriteria : getAvailableLabel()}}</p>
            </div>
          </div>
        </div>
      </div>


      <div class="section-description pd-top only-mobile">
        <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.SpecieDescription.Title' | translate}}</h2>
        <div class="section-description-info">
          <div class="rowInfo">
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.DescriptionText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.description ? speciesDescription.description : getAvailableLabel() }}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.TechnicalCharacteristicsText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.technicalCharacteristics ? speciesDescription.technicalCharacteristics : getAvailableLabel()}}</p>
            </div>
          </div>
          <div class="rowInfo">
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.ExportedVarietiesText' | translate}}:</span>
              <p class="text-info">{{exportOfferAd.variety.species.exportVarieties}}</p>
            </div>
            <div class="container-info">
              <span class="label-info">{{'ExportOffer.ExportOfferDetail.SpecieDescription.QualityControlCriteriaText' | translate}}:</span>
              <p class="text-info">{{speciesDescription.qualityControlCriteria ? speciesDescription.qualityControlCriteria : getAvailableLabel()}}</p>
            </div>
          </div>
        </div>
      </div>


      <div class="section-bottom">
        <div class="section-description">
          <h2 class="title-section">{{'ExportOffer.ExportOfferDetail.ProductDescription' | translate}}</h2>
          <div class="section-description-info">

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.SpeciesText' | translate}}:
              </span>
              <p class="small-data-info">
                {{ exportOfferAd.variety.species.name }}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.VarietyText' | translate}}:
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center">
                  <img [src]="exportOfferAd.variety.urlIcon | speciesImageUrl" style="width: 18px;margin-right:.5em;" alt="Variety icon"/>
                  <p class="small-data-info">
                    {{exportOfferAd.variety.name}}
                  </p>
                </div>
              </div>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.CategoryText' | translate}}:
              </span>
              <p class="small-data-info">
                <app-text-preview
                  [text]="exportOfferAd.category ? exportOfferAd.category : getAvailableLabel()"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.LocationLabel' | translate}}:
              </span>
              <p class="small-data-info">
                <app-text-preview *ngIf="exportOfferAd.fridgeStorage"
                  [text]="exportOfferAd.fridgeStorage.contactCity + ', ' + (exportOfferAd.fridgeStorage.contactCountry | countryDescription)"
                  [maxLength]="30">
                </app-text-preview>
                <app-text-preview *ngIf="!exportOfferAd.fridgeStorage"
                  [text]="exportOfferAd.country.name"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.HarvestDateText' | translate}}:
              </span>
              <p class="small-data-info" *ngIf="exportOfferAd.harvestTypeId === 1">
                {{exportOfferAd.harvestDate ? (exportOfferAd.harvestDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
              </p>
              <p class="small-data-info" *ngIf="exportOfferAd.harvestTypeId === 2 || exportOfferAd.harvestTypeId === 3 ">
              {{exportOfferAd.harvestStartDate ? (exportOfferAd.harvestStartDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
              -
              {{exportOfferAd.harvestEndDate ? (exportOfferAd.harvestEndDate | date: 'dd/MM/yyyy') : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.ShelfLife' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.shelfLife ? exportOfferAd.shelfLife + ' ' + translate.instant('ExportOffer.ExportOfferDetail.DayShelflifeText') : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.CasePerPalletsText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.caseQuantityPerPallet}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.SpeciesSizeText' | translate}}:
              </span>
              <p class="small-data-info">
                <app-text-preview
                  [text]="exportOfferAd.speciesSize ? exportOfferAd.speciesSize : getAvailableLabel()"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.SpeciesSizeMillimetersFieldText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.sizeMillimeters ? exportOfferAd.sizeMillimeters + ' mm.' : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.NetKilosText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.netKilos ? exportOfferAd.netKilos + ' Kg.' : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.GrossKilosText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.grossKilos ? exportOfferAd.grossKilos + ' Kg.' : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.BoxTypeText' | translate}}:
              </span>
              <p class="small-data-info">
                <app-text-preview
                  [text]="exportOfferAd.boxType ? getBoxType(exportOfferAd.boxType) : getAvailableLabel()"
                  [maxLength]="30">
                </app-text-preview>
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.Packaging' | translate}}:
              </span>
              <p class="small-data-info">
                {{ exportOfferAd.netKilos && exportOfferAd.packagingTypes ? getPackagingTypes(exportOfferAd.packagingTypes) : getNoAvailableLabel() }}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.BasePalletsText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.basePallets ? getBasePallets(exportOfferAd.basePallets) : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.ColorText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.color ? exportOfferAd.color : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.MarksText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.marks ? exportOfferAd.marks : getAvailableLabel()}}
              </p>
            </div>
            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.ReadyToLoadDateText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.readyToLoadDate ? (exportOfferAd.readyToLoadDate | date: 'dd-MM-yyyy') : getAvailableLabel()}}
              </p>
            </div>
            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.qualityControlText' | translate}}:
              </span>
              <p class="small-data-info">
                {{getIncludedLabel(exportOfferAd.isQualityControl)}}
              </p>
              <p-button *ngIf="exportOfferAd.qualityDocuments.length > 0" (onClick)="getExportOfferQualityDocument(exportOfferAd.qualityDocuments)" pTooltip="{{'UserPages.UserExportOffers.EditExportOffer.ViewQualityDocument' | translate}}" [style]="{ 'margin': 0, 'padding': 0 }" icon="pi pi-file-pdf" styleClass="p-button-link p-button-lg"></p-button>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.CaseSize' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.caseSize ? (exportOfferAd.caseSize) : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.QualityControlDateText' | translate}}:
              </span>
              <p class="small-data-info">
                {{exportOfferAd.qualityControlDate ? (exportOfferAd.qualityControlDate | date: 'dd-MM-yyyy') : getAvailableLabel()}}
              </p>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.OriginCountryText' | translate}}:
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center">
                  <img [flag]="(exportOfferAd.country.code) " style="width: 18px; margin-right:10px" alt=""/>
                  <p class="small-data-info">
                    {{exportOfferAd.country | countryDescription}}
                  </p>
                </div>
              </div>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.MarketCountry1Text' | translate}}:
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center">
                  <img [flag]="exportOfferAd.marketCountryFirst.code" style="width: 18px; margin-right:10px" alt=""/>
                  <p class="small-data-info">
                    {{exportOfferAd.marketCountryFirst ? (exportOfferAd.marketCountryFirst | countryDescription) : getAvailableLabel()}}
                  </p>
                </div>
              </div>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.MarketCountry2Text' | translate}}:
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center" *ngIf="exportOfferAd.marketCountrySecond">
                  <img [flag]="exportOfferAd.marketCountrySecond.code" style="width: 18px; margin-right:10px" alt=""/>
                  <p class="small-data-info">
                    {{exportOfferAd.marketCountrySecond ? (exportOfferAd.marketCountrySecond | countryDescription) : getAvailableLabel()}}
                  </p>
                </div>
                <div class="flex align-items-center"  *ngIf="!exportOfferAd.marketCountrySecond">
                  <p class="small-data-info">
                    {{'ExportOffer.ExportOfferDetail.NoAvailable' | translate}}
                  </p>
                </div>
              </div>
            </div>

            <div class="container-description-info">
              <span class="span-info" >
                {{'ExportOffer.ExportOfferDetail.MarketCountry3Text' | translate}}:
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center" *ngIf="exportOfferAd.marketCountryThird">
                  <img [flag]="exportOfferAd.marketCountryThird.code" style="width: 18px; margin-right:10px" alt=""/>
                  <p class="small-data-info">
                    {{exportOfferAd.marketCountryThird ? (exportOfferAd.marketCountryThird | countryDescription) : getAvailableLabel()}}
                  </p>
                </div>
                <div class="flex align-items-center" *ngIf="!exportOfferAd.marketCountryThird">
                  <p class="small-data-info">
                    {{'ExportOffer.ExportOfferDetail.NoAvailable' | translate}}
                  </p>
                </div>
              </div>
            </div>


            <div class="container-description-info">
              <span class="span-info" >
              </span>
              <div class="flex align-items-center">
                <div class="flex align-items-center">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</app-user-dashboard>
<app-footer-home></app-footer-home>
